import { CanAccess } from '@refinedev/core';
import { Edit, useForm } from '@refinedev/antd';
import { Form, Input, InputNumber } from 'antd';
import { IExternalItem } from 'interfaces/external_items';

export const ExternalItemEdit = () => {
  const { formProps, saveButtonProps, queryResult } = useForm<IExternalItem>({
    redirect: 'edit'
  });

  return (
    <CanAccess resource="external_items" action="edit">
      <Edit
        saveButtonProps={saveButtonProps}
        title="Editar item externo"
        isLoading={queryResult?.isLoading}
      >
        <Form {...formProps} layout="vertical">
          <Form.Item
            label="Nome"
            name="name"
            rules={[
              {
                required: true,
                message: 'Por favor, insira o nome do item externo'
              }
            ]}
          >
            <Input placeholder="Digite o nome do item externo" />
          </Form.Item>

          <Form.Item
            label="URL do Webhook"
            name="webhook_url"
            rules={[
              {
                required: true,
                message: 'Por favor, insira a URL do webhook'
              }
            ]}
          >
            <Input placeholder="https://exemplo.com/webhook" type="url" />
          </Form.Item>

          <Form.Item
            label="URL de Acesso"
            name="access_url"
            rules={[
              {
                required: true,
                message: 'Por favor, insira a URL de acesso'
              }
            ]}
          >
            <Input placeholder="https://exemplo.com/item" type="url" />
          </Form.Item>

          <Form.Item
            label="Duração (horas)"
            name="duration_in_hours"
            rules={[
              {
                required: true,
                message: 'Por favor, insira a duração em horas'
              },
              {
                type: 'number',
                min: 0.5,
                message: 'A duração deve ser pelo menos 0,5 horas'
              }
            ]}
          >
            <InputNumber
              placeholder="8"
              min={0.5}
              step={0.5}
              style={{ width: '200px' }}
            />
          </Form.Item>
        </Form>
      </Edit>
    </CanAccess>
  );
};
